export const SITE_EVENTS = {
  SITE_STATUS_CHANGED: 'site_status_changed'
}